/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchRunResult,
  ListOperations400Response,
  ListTargets200Response,
  RunBatchRequest,
} from '../models/index';
import {
    BatchRunResultFromJSON,
    BatchRunResultToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
    ListTargets200ResponseFromJSON,
    ListTargets200ResponseToJSON,
    RunBatchRequestFromJSON,
    RunBatchRequestToJSON,
} from '../models/index';

export interface ListTargetsRequest {
    issueDate: Date;
}

export interface RunBatchOperationRequest {
    runBatchRequest: RunBatchRequest;
}

/**
 * 
 */
export class BatchesApi extends runtime.BaseAPI {

    /**
     * バッチ処理対象一覧 issue_date を起点として、 condition.processing_period_kindで該当する精算処理日を設定している会社(company_relation)が属するPaymentGroupに紐づくバッチ処理対象一覧を取得します。 processing_period_kind: 1. 翌月1日, 2. 当月16日+翌月1日(月2回) 
     */
    async listTargetsRaw(requestParameters: ListTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTargets200Response>> {
        if (requestParameters['issueDate'] == null) {
            throw new runtime.RequiredError(
                'issueDate',
                'Required parameter "issueDate" was null or undefined when calling listTargets().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['issueDate'] != null) {
            queryParameters['issue_date'] = (requestParameters['issueDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/batches/targets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTargets200ResponseFromJSON(jsonValue));
    }

    /**
     * バッチ処理対象一覧 issue_date を起点として、 condition.processing_period_kindで該当する精算処理日を設定している会社(company_relation)が属するPaymentGroupに紐づくバッチ処理対象一覧を取得します。 processing_period_kind: 1. 翌月1日, 2. 当月16日+翌月1日(月2回) 
     */
    async listTargets(requestParameters: ListTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTargets200Response> {
        const response = await this.listTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * バッチ処理の実行
     */
    async runBatchRaw(requestParameters: RunBatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BatchRunResult>> {
        if (requestParameters['runBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'runBatchRequest',
                'Required parameter "runBatchRequest" was null or undefined when calling runBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/batches/run`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunBatchRequestToJSON(requestParameters['runBatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchRunResultFromJSON(jsonValue));
    }

    /**
     * バッチ処理の実行
     */
    async runBatch(requestParameters: RunBatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BatchRunResult> {
        const response = await this.runBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
